import React from 'react'
import { Checkbox } from 'antd'
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react'
import { addDays } from 'date-fns'
import { formatShiftDayLabel } from './shiftDateUtils'
import { formatShiftSlotLabel, getShiftBadgeClassByName } from './shiftLabelUtils'

function AddShiftMobileWeek({
    weekStart,
    shift,
    shiftDataNew,
    areCheckboxesEnabled,
    lang,
    monthLabel,
    periodLabel,
    frameLabel,
    onCheckboxChange,
    onPrevWeek,
    onNextWeek,
    onPrevMonth,
    onNextMonth,
}) {
    return (
        <div className="shift-week-mobile shift-week-mobile--edit">
            <div className="shift-week-mobile__month-nav">
                <a role="button" className="lh1 flex_item_cc" onClick={onPrevMonth}>
                    <ArrowLeft2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
                <h6>{monthLabel}</h6>
                <a role="button" className="lh1 flex_item_cc" onClick={onNextMonth}>
                    <ArrowRight2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
            </div>
            <div className="shift-week-mobile__week-nav">
                <a role="button" className="lh1 flex_item_cc" onClick={onPrevWeek}>
                    <ArrowLeft2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
                <h6>{periodLabel}</h6>
                <a role="button" className="lh1 flex_item_cc" onClick={onNextWeek}>
                    <ArrowRight2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
            </div>

            {Array.from({ length: 7 }).map((_, dayIndex) => {
                const day = addDays(weekStart, dayIndex)

                return (
                    <div key={dayIndex} className="border_card mb16">
                        <h6 className="shift-week-mobile__day-title">
                            {formatShiftDayLabel(day, dayIndex, lang)}
                        </h6>
                        <div className="shift-week-mobile__shift-rows">
                            {shift.map((data) => {
                                const checkboxName = data.name + 'D' + dayIndex
                                const checked = Boolean(
                                    shiftDataNew[dayIndex]?.shift?.includes(checkboxName)
                                )

                                return (
                                    <label
                                        key={data.name}
                                        className="shift-week-mobile__shift-row"
                                    >
                                        <span
                                            className={`shift_badge shift_badge--labeled ${getShiftBadgeClassByName(data.name)}`}
                                        >
                                            {formatShiftSlotLabel(data, { lang, frameLabel })}
                                        </span>
                                        <Checkbox
                                            checked={checked}
                                            disabled={!areCheckboxesEnabled}
                                            onChange={(e) =>
                                                onCheckboxChange(e, checkboxName)
                                            }
                                        />
                                    </label>
                                )
                            })}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default AddShiftMobileWeek
